export const CUSTOMERS_FETCH = 'CUSTOMERS_FETCH';
export const CUSTOMERS_FETCH_SUCCESS = 'CUSTOMERS_FETCH_SUCCESS';
export const CUSTOMERS_FETCH_FAIL = 'CUSTOMERS_FETCH_FAIL';
export const CUSTOMER_SELECT = 'CUSTOMER_SELECT';
export const CUSTOMER_UPDATE = 'CUSTOMER_UPDATE';
